<template>
    <div class="overflow-auto">
        <table class="table-fixed text-left my-14">
            <thead class="border-b-2">
                <tr>
                    <th v-for="(column, index) in columns" :key="column.name" :class="{'border-r border-grey w-86': index === 0}" class="truncate max-w-174 pb-10 px-8">
                        {{ column.label }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in rows" class="border-b border-grey">
                    <td v-for="(value, index) in row" :class="{'border-r border-grey': index === 0}"  class="whitespace-no-wrap pb-10 px-8">
                        <template v-if="value">
                            {{ value }}
                        </template>
                        <template v-else>
                            0
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

    import { format } from "date-fns"

    export default {

        props: {
            chartData: {
                type: Object,
                required: true,
            },

            scheme: {
                type: String,
                default: 'dark'
            },
        },

        computed: {
            hasTargets() {
                return this.chartData.datasets.findIndex(dataset => dataset.target) > -1
            },

            columns() {
                let columns = this.chartData.datasets.map(dataset => {
                    return {field: dataset.field, label: dataset.label}
                })

                return [{field: 'date', label: 'Date'}].concat(columns)
            },

            rows() {
                let rows = []

                this.chartData.labels.forEach((label, index) => {
                   let row = [label]

                    this.chartData.datasets.forEach(dataset => row.push(dataset.data[index]))

                    rows.push(row)
                });

                return rows
            },
        },

    }
</script>